module.exports = __webpack_public_path__ + "static/media/github.49355eeb.png";